import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  showError(message: string): void {
    this.showMessage(message, ['bg-error']);
  }

  showInfo(message: string): void {
    this.showMessage(message, ['bg-info']);
  }

  showSuccess(message: string): void {
    this.showMessage(message, ['bg-success']);
  }

  private showMessage(
    message: string,
    customClass: string[],
    duration = 10000
  ): void {
    const config = new MatSnackBarConfig();
    config.panelClass = [...customClass];
    config.duration = duration;
    this.snackBar.open(
      this.translateService.instant(message),
      undefined,
      config
    );
  }
}
